<script>
  import { createEventDispatcher } from 'svelte';
  import { selectedGroup } from '../store';
  import { Modal, ModalBody, ModalFooter, ModalHeader } from 'sveltestrap';
  import http from '../api/http.js';
  import Validator from '../Helpers/Validator';
  
  const dispatch = createEventDispatcher();

  let shown = false;
  let software;
  let tempSoftware;
  let errorMessage = "";

  export async function show(softwareArg) {
    software = softwareArg;
    tempSoftware = software.name;
    shown = true;
  }

  function toggle() {
    if(shown){
      shown = false;
      resetModal();
    }else{
      shown = true;
    }
  }

  function resetModal(){
    errorMessage = '';
  }

  function validateName(name){
    if(name.length < 100 ){
      if(name.length > 1){
        if(Validator.regex(name, /^[a-zA-Z0-9\s]*$/)){
          errorMessage = "";
        }else{
          errorMessage = "Name cannot contain special characters.";
        }
      }else{
        errorMessage = "Name cannot be blank";
      }
    }else{
      errorMessage = "Name cannot be longer than 100 characters.";
    }
  }

  async function editSoftware() {
    validateName(tempSoftware);
    
    if(errorMessage == ""){
      software.name = tempSoftware;
      software.displayName = tempSoftware;
      const res = await http.put(window.apiBaseUrl + `/deploy/dashboard/software/${$selectedGroup}`, software);

      if (res.ok) {
        dispatch('softwareEdited');
        toggle();
      }
    }
  }

  function _onYes() {
    editSoftware();
  }

  function _onNo() {
    shown = false;
  }

</script>

<Modal size="lg" isOpen={shown} {toggle}>
  <ModalHeader {toggle}>Edit Software</ModalHeader>
  <ModalBody>
    <div class="col">
      <h4 class="input-header mt-2 m-2 mb-2">Name</h4>
      <input id="software-name-input" type="text" class="form-control" bind:value={tempSoftware} on:input={() => validateName(tempSoftware)}/>
      <p class="text-danger">{errorMessage}</p>
    </div>
  </ModalBody>
  <ModalFooter>
    <button id="delete-software-cancel-button" class="btn btn-outline-primary" on:click={() => _onNo()}>Cancel</button>
    <button id="delete-software-confirm-button" on:click={() => _onYes()} class="btn btn-primary" disabled={errorMessage != ""}>Confirm</button>
  </ModalFooter>
</Modal>

<style>
  @import "@uppy/core/dist/style.css";
  @import "@uppy/dashboard/dist/style.css";
  
  input[type="text"]:disabled{
    background-color: #e9ecef;
  }

</style>